import { useSelector } from "react-redux";
import { getReturnedProducts } from "../../product/all-products/redux/Reducers/paginationReducer";
import { useEffect, useRef, useState, useMemo } from "react";
import ReactDOM from "react-dom";
import { Box, Typography } from "@mui/material";
import { ReturnedItems } from "./returnedItems";
import { OrderItemDetails } from "./orderItemDetails";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "layouts/ecommerce/posnavbar/Navbar";
import {
  calculcateReturnAmount,
  createReturn,
  getOrderDetails,
} from "../../../../config/Services";
import { useSnackbar } from "../../product/hooks/SnackbarProvider";
import useGetDevice from "../../product/hooks/useGetDevice";
import usePrint from "../../product/hooks/usePrint";
import Swal from "sweetalert2";
import { setReturnedItems } from "../../product/all-products/redux/Actions/paginationActions";
import { useDispatch } from "react-redux";
import { customEventTrigger } from "../../../../analytics";
import newUpiIcon from "../../../../assets/images/upi-new.png";
import newCashIcon from "../../../../assets/images/cash-new.png";
import newCardIcon from "../../../../assets/images/new-card-def.png";
import newCardSelectedIcon from "../../../../assets/images/card-new.png";
import newCashSelectedIcon from "../../../../assets/images/cash-new-selected.png";
import newUpiSelectedIcon from "../../../../assets/images/upi-new-selected.png";
import "./ReturnsCreation.css";
import { formatDate } from "../../product/all-products/CustomerV2Preview/Component/helper/helper";
import { debounce } from "lodash";

const newSwal = Swal.mixin({
  customClass: {
    confirmButton: "button button-success",
    cancelButton: "button button-error",
    container: "my-swal-container",
  },
  buttonsStyling: false,
});

/* ─── Custom Checkbox ─── */
const CustomCheckbox = ({ checked, onChange }) => (
  <button
    type="button"
    role="checkbox"
    aria-checked={checked}
    data-state={checked ? "checked" : "unchecked"}
    onClick={() => onChange(!checked)}
    style={{
      width: "16px",
      height: "16px",
      display: "grid",
      placeContent: "center",
      borderRadius: "67px",
      border: `1.5px solid ${checked ? "#2A71FF" : "#cbd5e1"}`,
      backgroundColor: checked ? "#2A71FF" : "transparent",
      cursor: "pointer",
      flexShrink: 0,
      boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    }}
  >
    {checked && (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20 6 9 17l-5-5" />
      </svg>
    )}
  </button>
);

/* ─── SVG icon helpers ─── */
const ArrowLeft = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="m12 19-7-7 7-7" />
    <path d="M19 12H5" />
  </svg>
);
const ShieldCheck = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
    <path d="m9 12 2 2 4-4" />
  </svg>
);
const Minus = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14" />
  </svg>
);
const Plus = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5 12h14" />
    <path d="M12 5v14" />
  </svg>
);
const XIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 6 6 18" />
    <path d="m6 6 12 12" />
  </svg>
);
const WalletIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
    <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
  </svg>
);
const UpiIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
  </svg>
);
const CardIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <line x1="2" y1="10" x2="22" y2="10" />
  </svg>
);

/* ════════════════════════════════════════════
   ReturnsCreation
   ════════════════════════════════════════════ */
export const ReturnsCreation = () => {
  const dispatch = useDispatch();
  const returnItemArray = useSelector(getReturnedProducts);
  const [totalOriginal, setTotalOriginal] = useState({});
  const [totalReturned, setTotalReturned] = useState({});
  const [isReturning, setIsReturning] = useState(false);
  const location = useLocation();
  const { id } = useParams();
  const { state } = location;
  const orderItems = state?.orderItems;
  const locId = localStorage.getItem("locId");
  const retailUserDetails = JSON.parse(localStorage.getItem("retailUserDetails"));
  const firstName = retailUserDetails?.firstName;
  const secondName = retailUserDetails?.secondName;
  const navigate = useNavigate();
  const tableRef = useRef(null);
  const returnTableRef = useRef(null);
  const showSnackbar = useSnackbar();
  const [refundMode, setRefundMode] = useState("CASH");
  const [paymentButtons, setPaymentButtons] = useState([
    {
      method: "CASH",
      icon: newCashIcon,
      selectedIcon: newCashSelectedIcon,
      label: "Cash",
      disabled: false,
    },
    {
      method: "UPI",
      icon: newUpiIcon,
      selectedIcon: newUpiSelectedIcon,
      label: "UPI",
      disabled: true,
    },
    {
      method: "CARD",
      icon: newCardIcon,
      selectedIcon: newCardSelectedIcon,
      label: "Card",
      disabled: true,
    },
  ]);
  const licenseId = localStorage.getItem("licenseId");
  const sessionId = localStorage.getItem("sessionId");

  const { startPrint, isPrinting } = usePrint();
  const isMobile = useGetDevice();
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const [customerName, setCustomerName] = useState(state?.customerName || "");
  const [inputValues, setInputValues] = useState({});

  useEffect(() => {
    getOrderDetails(id, locId)
      .then((res) => {
        const name = res?.data?.data?.baseOrderResponse?.customerName;
        if (name) setCustomerName(name);
      })
      .catch(() => {});
  }, [id]);

  const handlePaymentModal = () => {
    if (returnItemArray.length < 1) {
      showSnackbar("Please add at least 1 item to proceed.", "error");
      return;
    }
    setOpen(true);
  };

  const transformReturnItemArray = (arr) =>
    arr?.map((item) => ({
      orderId: id,
      orderItemId: item?.orderItemId,
      gtin: item?.gtin,
      updatedBy: `${firstName} ${secondName}`,
      productName: item?.productName,
      mrp: item?.mrp,
      sellingPrice: item?.sellingPrice,
      qtyReturned: Number(item?.returnedQty),
      batchId: item?.batchNo,
      returnType: "return",
      loggedInUserId: retailUserDetails.uidx,
      sessionId,
    }));

  const handleReturnedItems = async () => {
    const payload = {
      orderId: id,
      locationId: locId,
      updatedBy: `${firstName} ${secondName}`,
      returnItems: transformReturnItemArray(returnItemArray),
      licenseId,
      sessionId,
      returnMode: refundMode,
    };

    payload.returnItems?.forEach((item) => customEventTrigger("pos_item_returned", item));

    try {
      setIsReturning(true);

      const res = await createReturn(payload);

      setOpen(false);

      startPrint({
        orderId: id,
        printType: "credit-note",
        returnId: res?.data?.data?.baseOrderResponse?.returnId,
        skipKot: true,
      });

      newSwal.fire({
        title: `${returnItemArray.length} ${
          returnItemArray.length === 1 ? "item is" : "items are"
        } returned successfully from order ${id}`,
        icon: "info",
        confirmButtonText: "Continue",
        preConfirm: () => {
          navigate("/orders", { state: { initialTab: "Returns" } });
        },
      });
    } catch (err) {
      showSnackbar(err?.message || err?.data?.response?.message, "error");
    } finally {
      setIsReturning(false);
    }
  };

  const handleItemSelect = (item, isSelected) => {
    if (isSelected) {
      dispatch(
        setReturnedItems(returnItemArray?.filter((r) => r?.orderItemId !== item?.orderItemId))
      );
    } else {
      dispatch(
        setReturnedItems([
          ...returnItemArray,
          {
            orderItemId: item?.orderItemId,
            gtin: item?.gtin,
            productName: item?.productName,
            mrp: item?.mrp,
            sellingPrice: item?.sellingPrice,
            returnedQty: item?.quantityBySpecs ? item?.quantityBySpecs : 1,
            batchNo: item?.batchNo,
          },
        ])
      );
    }
  };

  const handleQuantityChange = (item, newQty) => {
    const isWeighing = !!item?.quantityBySpecs;
    const maxQty = isWeighing ? Number(item?.quantityBySpecs) : item?.quantity || 1;
    const minQty = isWeighing ? 0.01 : 1;
    if (isWeighing) {
      const raw = String(newQty);
      const numVal = parseFloat(raw);
      if (!isNaN(numVal) && numVal > maxQty) return;
      setInputValues((prev) => ({ ...prev, [item?.orderItemId]: raw }));
      if (isNaN(numVal) || numVal < minQty) return;
      dispatch(
        setReturnedItems(
          returnItemArray?.map((r) =>
            r?.orderItemId === item?.orderItemId ? { ...r, returnedQty: numVal } : r
          )
        )
      );
      return;
    }
    const validQty = Math.min(Math.max(1, Number(newQty) || 1), item?.quantity || 1);
    dispatch(
      setReturnedItems(
        returnItemArray?.map((r) =>
          r?.orderItemId === item?.orderItemId ? { ...r, returnedQty: validQty } : r
        )
      )
    );
  };

  const handleReturnAll = () => {
    if (isAllSelected) {
      dispatch(setReturnedItems([]));
    } else {
      dispatch(
        setReturnedItems(
          orderItems?.map((item) => ({
            orderItemId: item?.orderItemId,
            gtin: item?.gtin,
            productName: item?.productName,
            mrp: item?.mrp,
            sellingPrice: item?.sellingPrice,
            returnedQty: item?.quantityBySpecs ? item?.quantityBySpecs : 1,
            batchNo: item?.batchNo,
          }))
        )
      );
    }
  };

  const isAllSelected =
    orderItems?.length > 0 &&
    orderItems?.every((item) => returnItemArray?.some((r) => r?.orderItemId === item?.orderItemId));

  const exceedsOriginalQty = returnItemArray?.some((item) => {
    const orderItem = orderItems?.find((o) => o?.orderItemId === item?.orderItemId);
    const maxQty = orderItem?.quantityBySpecs ? Number(orderItem?.quantityBySpecs) : orderItem?.quantity || 1;
    return Number(item?.returnedQty) > maxQty;
  });

  const debouncedCalculateReturnAmount = useMemo(
    () =>
      debounce(() => {
        if (returnItemArray?.length === 0 || exceedsOriginalQty) return;
        const payload = {
          orderId: id,
          locationId: locId,
          updatedBy: `${firstName} ${secondName}`,
          returnItems: transformReturnItemArray(returnItemArray),
        };
        calculcateReturnAmount(payload).then((res) => {
          if (res?.data?.data?.es) {
            const formattedMessage = res?.data?.data?.message?.split("_").join(' ')
            showSnackbar(formattedMessage, "error");
            return;
          }
          const totalOriginalQty = orderItems?.reduce(
            (acc, item) => acc + (item?.quantityBySpecs || 0),
            0
          );
          const totalReturnedQty = returnItemArray?.reduce(
            (acc, item) => acc + (Number(item?.returnedQty) || 0),
            0
          );
          setTotalReturned({
            total: Math.abs(res?.data?.data?.orderResponseModel?.amountToBePaid),
            qty: totalReturnedQty,
          });
          setTotalOriginal({
            total: res?.data?.data?.orderResponseModel?.amountPaid,
            qty: totalOriginalQty,
          });
        });
      }, 500),
    [returnItemArray, orderItems, exceedsOriginalQty]
  );

  useEffect(() => {
    debouncedCalculateReturnAmount();
    return () => debouncedCalculateReturnAmount.cancel();
  }, [returnItemArray, orderItems, exceedsOriginalQty]);

  useEffect(() => {
    dispatch(setReturnedItems([]));
    if (tableRef?.current) tableRef.current.focus();
  }, []);

  const hasSelection = returnItemArray?.length > 0;
  const returnValue = totalReturned?.total || 0;
  const returnQty = totalReturned?.qty || 0;

  return (
    <Navbar>
      {/* <TableStyleOverride /> */}

      {/* ── Page shell ── */}
      <div className="rd-page">
        <div className="rd-scroll-area">
          {/* ── Sticky header ── */}
          <div className="rd-sticky-header">
            <div className="rd-header-inner">
              <button className="rd-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
                <ArrowLeft />
              </button>
              <div className="rd-header-title-group">
                <div className="rd-header-title-row">
                  <h1 className="rd-header-title">New Return</h1>
                  <span className="rd-order-badge">Order {id}</span>
                </div>
              </div>
            </div>
          </div>

          {/* ── Body ── */}
          <div className="rd-body">
            {/* ── Context card ── */}
            <div className="rd-context-card">
              <div style={{ minWidth: 0 }}>
                <p className="rd-context-label">Return Context</p>
                <div className="rd-context-meta">
                  <span className="rd-context-meta-name">{customerName || "Walk-in customer"}</span>
                  <span>{formatDate(state?.createdAt || "—")}</span>
                  <span>{state?.paymentMethod || "Cash"}</span>
                  <span className="rd-context-meta-overflow">
                    {state?.returnReason || "Manager initiated return"}
                  </span>
                </div>
              </div>

              <div className="rd-manager-badge">
                <div className="rd-manager-icon">
                  <ShieldCheck />
                </div>
                <div>
                  <div className="rd-manager-name">
                    {firstName} {secondName}
                  </div>
                  <p className="rd-manager-role">Store Manager</p>
                </div>
              </div>
            </div>

            {/* ── Item table card ── */}
            <div className="rd-table-card">
              <div className="rd-table-card-header">
                <div>
                  <p className="rd-table-sub-label">Original Item List</p>
                  <h2 className="rd-table-title">Select lines to return</h2>
                </div>

                <label
                  className="rd-return-all-toggle"
                  data-testid="toggle-return-create-return-all"
                >
                  <CustomCheckbox checked={isAllSelected} onChange={handleReturnAll} />
                  Return All
                </label>
              </div>

              <div className="return-details-table-wrapper rd-table-wrap">
                <table>
                  <thead>
                    <tr>
                      {[
                        "Select",
                        "Product",
                        "Barcode",
                        "Batch",
                        "MRP",
                        "Selling",
                        "Original Qty",
                        "Return Qty",
                      ]?.map((h) => (
                        <th key={h}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {orderItems?.map((item, idx) => {
                      const returnItem = returnItemArray?.find(
                        (r) => r?.orderItemId === item?.orderItemId
                      );
                      const isSelected = !!returnItem;
                      const currentQty = Number(returnItem?.returnedQty) || 1;
                      const maxQty = item?.quantityBySpecs ? Number(item?.quantityBySpecs) : item?.quantity || 1;
                      const minQty = item?.quantityBySpecs ? 0.01 : 1;
                      const step = item?.quantityBySpecs ? 0.01 : 1;

                      return (
                        <tr
                          key={item?.orderItemId || idx}
                          className={
                            isSelected ? "rd-table-row--selected" : "rd-table-row--default"
                          }
                          style={{ borderTop: "1px solid #f1f5f9" }}
                        >
                          <td>
                            <CustomCheckbox
                              checked={isSelected}
                              onChange={() => handleItemSelect(item, isSelected)}
                            />
                          </td>
                          <td>
                            <div className="rd-cell-product-name">{item?.productName}</div>
                          </td>
                          <td className="rd-cell-small">{item?.gtin || "—"}</td>
                          <td className="rd-cell-small">{item?.batchNo || "—"}</td>
                          <td className="rd-cell-price">₹{item?.mrp}</td>
                          <td className="rd-cell-price">₹{item?.sellingPrice}</td>
                          <td className="rd-cell-qty">{item?.quantityBySpecs ?? item?.quantity}</td>
                          <td>
                            <div className="rd-qty-control">
                              <button
                                className={`rd-qty-btn ${
                                  isSelected ? "rd-qty-btn--active" : "rd-qty-btn--disabled"
                                }`}
                                onClick={() =>
                                  isSelected && handleQuantityChange(item, currentQty - 1)
                                }
                                disabled={!isSelected || currentQty <= 1}
                                aria-label="Decrease"
                              >
                                <Minus />
                              </button>
                              <input
                                className={`rd-qty-input ${
                                  isSelected ? "rd-qty-input--active" : "rd-qty-input--disabled"
                                }`}
                                type="number"
                                disabled={!isSelected}
                                value={item?.quantityBySpecs ? (inputValues[item?.orderItemId] ?? currentQty) : currentQty}
                                onChange={(e) =>
                                  handleQuantityChange(item, e.target.value)
                                }
                                step={step}
                                min={minQty}
                                max={maxQty}
                              />
                              <button
                                className={`rd-qty-btn ${
                                  isSelected ? "rd-qty-btn--active" : "rd-qty-btn--disabled"
                                }`}
                                onClick={() =>
                                  isSelected && handleQuantityChange(item, currentQty + 1)
                                }
                                disabled={!isSelected || currentQty >= maxQty}
                                aria-label="Increase"
                              >
                                <Plus />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* /body */}
        </div>
        {/* /scroll-area */}

        {/* ── Bottom action bar ── */}
        <div className="rd-action-bar">
          <div className="rd-action-bar-inner">
            <div className="rd-summary-min-width">
              <p className="rd-summary-title">
                {returnItemArray?.length} {returnItemArray?.length === 1 ? "item" : "items"}{" "}
                selected &nbsp;•&nbsp;₹{returnValue} return value
              </p>
              <p className="rd-summary-subtitle">{returnQty} total return qty</p>
            </div>
            <button
              className={`rd-proceed-btn${!hasSelection ? " rd-proceed-btn--disabled" : ""}`}
              disabled={!hasSelection}
              onClick={handlePaymentModal}
            >
              Proceed
            </button>
          </div>
        </div>
      </div>
      {/* /page */}

      {/* ── Refund drawer ── */}
      {open &&
        ReactDOM.createPortal(
          <>
            <div className="rd-drawer-backdrop" onClick={onClose} />
            <div className="rd-drawer">
              {/* Header */}
              <div className="rd-drawer-header">
                <h2 className="rd-drawer-title">Return details</h2>
                <button className="rd-close-btn" onClick={onClose} aria-label="Close">
                  <XIcon />
                </button>
              </div>

              {/* Body */}
              <div className="rd-drawer-body">
                {/* Summary card */}
                <div className="rd-summary-card">
                  {[
                    ["Cart items", orderItems?.length ?? 0],
                    ["Returned items", returnItemArray?.length ?? 0],
                    ["Original total", `₹${totalOriginal?.total ?? 0}`],
                    ["Return value", `₹${totalReturned?.total ?? 0}`],
                  ]?.map(([label, value], idx, arr) => (
                    <div key={label}>
                      <div className="rd-detail-row">
                        <span className="rd-detail-label">{label}</span>
                        <span className="rd-detail-value">{value}</span>
                      </div>
                      {idx < arr?.length - 1 && <div className="rd-summary-divider" />}
                    </div>
                  ))}
                </div>

                {/* Payment mode */}
                <div className="rd-payment-section">
                  <p className="rd-section-label">Select payment mode</p>
                  <div className="rd-payment-grid">
                    {paymentButtons?.map((btn) => (
                      <button
                        key={btn?.method}
                        className={[
                          "rd-payment-btn",
                          refundMode === btn?.method ? "rd-payment-btn--selected" : "",
                          btn?.disabled ? "rd-payment-btn--disabled" : "",
                        ]
                          .join(" ")
                          .trim()}
                        onClick={() => !btn?.disabled && setRefundMode(btn?.method)}
                        disabled={btn?.disabled}
                      >
                        {btn?.method === "CASH" && <WalletIcon />}
                        {btn?.method === "UPI" && <UpiIcon />}
                        {btn?.method === "CARD" && <CardIcon />}
                        <span
                          className={
                            refundMode === btn?.method
                              ? "rd-payment-label--active"
                              : "rd-payment-label"
                          }
                        >
                          {btn?.label}
                        </span>
                      </button>
                    ))}
                  </div>
                </div>

                {/* Refund amount */}
                <div className="rd-payment-section">
                  <p className="rd-section-label">Refund amount</p>
                  <div className="rd-amount-box">
                    <span className="rd-amount-value">₹{totalReturned?.total ?? 0}</span>
                    <span className="rd-amount-via">via {refundMode}</span>
                  </div>
                </div>

                {/* Confirm */}
                <div className="rd-confirm-section">
                  <button
                    className="rd-confirm-btn"
                    onClick={handleReturnedItems}
                    disabled={isReturning}
                  >
                    {isReturning ? <span className="rd-btn-loader" /> : "Confirm return"}
                  </button>
                </div>
              </div>
            </div>
          </>,
          document.body
        )}
    </Navbar>
  );
};
